export default {"src":"/_next/static/media/CM.51a176b8.svg","height":18,"width":18};